import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import DateView from 'react-datepicker';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import 'react-datepicker/dist/react-datepicker.css';
import './FormComponents.scss';
import calendar from 'assets/images/calendar.png';

const DateInput = ({ label, gif, name, isRequired, ...rest }) => {
  const { t } = useTranslation();
  return (
  <div className="question__datepicker">
    <div className='question__datepicker-icon'>
      <img src={calendar} alt="calendar" />
    </div>
    <label className='question__datepicker-label' htmlFor={name}>{label}</label>
    {!!gif && (
      <div className="question__gif">
        <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
      </div>
    )}
    <Field name={name}>
      {({ form, field }) => {
        const { setFieldValue } = { ...form };
        const { value } = { ...field };
        return (
          <DateView
            {...field}
            {...rest}
            id={name}
            dateFormat="yyyy/MM/dd"
            selected={value}
            onChange={(val) => setFieldValue(name, val)}
            showPopperArrow={false}
            showMonthDropdown
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
            maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
            className="input"
            placeholderText={t('formLabel.datepick')}
            onFocus={e => e.target.blur()}
          />
        );
      }}
    </Field>
  </div>
  )
};

DateInput.defaultProps = {
  gif: '',
};

DateInput.propTypes = {
  label: PropTypes.string.isRequired,
  gif: PropTypes.string,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
};

export default DateInput;
